// Copyright (c) Microgreen Manager LLC. All rights reserved. Proprietary and confidential. Unauthorized copying is strictly prohibited.
import { styled } from '@mui/material/styles';
// biome-ignore lint/style/useImportType: <explanation>
import * as React from 'react';
import { Link } from 'react-router-dom';
import { useLoggedInState } from '../../../context/LoggedInContext';
import { Typography } from '../../../lib/base';
// import { TitleLogo } from '../../common/logo';
import * as routes from '../../../routes';

const StyledLink = styled(Link)({
  textDecoration: 'none',
  cursor: 'pointer',
  textAlign: 'center',
});

const StyledTitle = styled(Typography)(({ theme }) => ({
  // 1200px and up
  [theme.breakpoints.up('lg')]: {
    fontSize: '2rem',
  },
  // 1020px - 1200px
  '@media (max-width: 1200px) and (min-width: 1020px)': {
    fontSize: '1.8rem',
  },
  // 900px - 1020px
  '@media (max-width: 1020px) and (min-width: 900px)': {
    fontSize: '1.7rem',
  },
  // 600px - 900px
  [theme.breakpoints.only('sm')]: {
    fontSize: '1.7rem',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1.4rem',
  },
  transition: 'ease-in-out all 0.2s',
}));

const StyledTagline = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.up('lg')]: {
    fontSize: '1.4rem',
    letterSpacing: '2px',
  },
  // 1020px - 1200px
  '@media (max-width: 1200px) and (min-width: 1020px)': {
    fontSize: '1.3rem',
    letterSpacing: '1.5px',
  },
  // 900px - 1020px
  '@media (max-width: 1020px) and (min-width: 900px)': {
    fontSize: '1.1rem',
    letterSpacing: '1px',
  },
  [theme.breakpoints.only('sm')]: {
    fontSize: '1.2rem',
    letterSpacing: '1px',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '1rem',
  },
  transition: 'ease-in-out all 0.2s',
}));

interface Props {
  id: string;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function TitleLink({ id }: Props): React.ReactElement {
  const { isLoggedIn } = useLoggedInState();
  return (
    <StyledLink to={isLoggedIn ? routes.DASHBOARD : routes.HOME}>
      {/* <TitleLogo id={id} /> */}
      <StyledTitle sx={{ mb: '4px' }} color="primary.contrastText" variant="h1">
        Microgreen Manager
      </StyledTitle>
      <StyledTagline color="secondary.light" variant="h2">
        Plant more. Plan less.
      </StyledTagline>
    </StyledLink>
  );
}
